export default __webpack_public_path__ + "static/media/spratt8.e9ad1e6b.jpg";